/**
 * Polygon fill opacities for steps that separate the frames under review from
 * the rest of the plan by hue rather than by opacity: the reviewable frames
 * carry the step accent and the others carry `internalFrameColorHex`.
 *
 * Both sit near-opaque because the plan detail that matters on these steps lies
 * between the walls rather than under them, so a translucent wall buys nothing
 * and costs the contrast that makes the distinction readable at plan zoom.
 */
export const PlanClarityRendering = {
	fillAlpha: 0.75,
	hoverFillAlpha: 0.95,
} as const;
